<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <div v-if="modal" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-10">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline" v-if="file">
                ADJUNTAR <b>{{ file.name }}</b>
              </h3>
              <div class="flex flex-col px-10 xl:px-0">
                <div class="flex flex-col px-10 xl:px-0 pt-2 pb-2">
                  <input type="file" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600" @change="handleFile" accept="image/jpeg,image/png,application/pdf">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="closeModal"
              type="button" 
              class="inline-flex justify-center bg-transparent hover:bg-red-500 text-xs text-red-700 font-semibold hover:text-white py-2 px-2 border border-red-500 hover:border-transparent rounded">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                </path>
              </svg>
              Cancelar
            </button>
          </span>
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              v-if="uploadFile != null"
              :disabled="loading"
              :class="[loading ? 'cursor-wait opacity-50' : '']"
              @click="upload"
              class="inline-flex justify-center bg-transparent hover:bg-green-500 text-xs text-green-700 font-semibold hover:text-white py-2 px-2 border border-green-500 hover:border-transparent rounded">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-500 cursor-pointer"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                </path>
              </svg>
              Aceptar
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueAlertify from 'vue-alertify';

Vue.use(VueAlertify);

export default {
  props: {
      claim: null,
      file: null,
      victim: null,
      modal: false
  },

  data() {
    return {
      loading: false,
      uploadFile: null
    }
  },

  methods: {
    closeModal() {
      this.uploadFile = null
      this.$emit('closeModalUpload', false)
    },
    handleFile(e) {
      const selected = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (e) => {
        this.uploadFile = e.target.result
      }
      reader.readAsDataURL(selected)
    },
    async upload() {
      try {
        this.loading = true
        this.file.file = this.uploadFile
        const params = {
          'file_option': JSON.stringify(this.file)
        }
        if (this.victim != null){
          await this.$http.put(`claims/victim/${this.victim}/file`, params)
        } else {
          await this.$http.put(`/claims/${this.claim.id}/file`, params)
        }  
        this.uploadFile = null
        this.$alertify.success('Archivo agregado al reclamo!') 
        this.loading = false
        this.$emit('closeModalUpload', true)
      } catch (error) {
        this.loading = false
        this.$alertify.error('ERROR. No se ha podido subir el archivo!')
      } 
    },
  },
}
</script>

